import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
const mixin = {
  mixins: [validationMixin],
  validations: {
    seasonName: { required },
  },
  computed: {
    seasonNameErrors() {
      const errors = [];
      if (!this.$v.seasonName.$dirty) return errors;
      !this.$v.seasonName.required &&
        errors.push("シーズン名を入力してください。");
      return errors;
    },
  },
};

export default mixin;
